import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import { Info } from 'lib/styles';

const Container = styled.div`
	padding: 16px 40px;
`;

const Map = props => {
	const {
		t,
	} = props;

	return (
		<Container>
			<Info
				icon="light-bulb"
				fill="orange"
				info={t('controls/map/info/default')}
			/>
		</Container>
	)
}

Map.propTypes = {
	t: PropTypes.func,
}

export default translate('translations')(Map)
